// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { SettingsCollectionModel } from "@insite/client-framework/Services/SettingsService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection as optimizelyGetSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";

interface CustomSettingsCollectionModel extends SettingsCollectionModel {
    customSettings: {
        notFoundLargeImagePath: string;
        notFoundMediumImagePath: string;
        notFoundSmallImagePath: string;
        cloudinaryBaseUrl: string;
        smallDefaultCategoryImage: string;
        brandName: string;
        billTrustImagePath: string;
        wernerGenerateListCustomerRestriction: string;
        enableChat: boolean;
        numberOfAttributesToDisplay: number;
        numberOfAttributeValuesToDisplay: number;
        customersWithCallWhenComplete: string;
        isUsWebSite: boolean;
        isPunchout: boolean;
        enableCancelPunchout: boolean;
        showUpsellsModal: boolean;
        paymentPortalLink: string;
        checkoutPhoneNumber: string;
        disableAddressValidation: boolean;
        enableHardRedirects: boolean;
        enableDropShipModule: boolean;
        rmaReasonDescriptionsForRequiredImages: string;
        rmaDelayValue?: number;
    };
    cloudinarySettings: {
        productImagePath: string;
        mediaRootPath: string;
        cloudName: string;
    };
    chatSettings: {
        chatSource: string;
        applicationId: string;
        applicationSecret: string;
        controlsType: string;
        controlsId: string;
    };
}

export function getSettingsCollection(state: ApplicationState): CustomSettingsCollectionModel {
    return optimizelyGetSettingsCollection(state) as CustomSettingsCollectionModel;
}
